function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-5431788c\",\"scoped\":false,\"hasInlineConfig\":false}!stylus-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./namespace-settings.vue")
}
var normalizeComponent = require("!../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"configFile\":\"/usr/build/babel.config.js\"}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./namespace-settings.vue"
import __vue_script__ from "!!babel-loader?{\"configFile\":\"/usr/build/babel.config.js\"}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./namespace-settings.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5431788c\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./namespace-settings.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/routes/namespace/namespace-settings.vue
// module id = 1508
// module chunks = 0